<template>
  <router-view />
</template>

<script>
export default {
  name: 'network-pages-container',
};
</script>
